/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WalletDetailsInput
 */
export interface WalletDetailsInput {
    /**
     * 
     * @type {string}
     * @memberof WalletDetailsInput
     */
    accountid?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletDetailsInput
     */
    email?: string;
}

/**
 * Check if a given object implements the WalletDetailsInput interface.
 */
export function instanceOfWalletDetailsInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WalletDetailsInputFromJSON(json: any): WalletDetailsInput {
    return WalletDetailsInputFromJSONTyped(json, false);
}

export function WalletDetailsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletDetailsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountid': !exists(json, 'accountid') ? undefined : json['accountid'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function WalletDetailsInputToJSON(value?: WalletDetailsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountid': value.accountid,
        'email': value.email,
    };
}

